/* eslint no-process-env: "off" */
const getAppVersion = () => {
  if (process.env.NEXT_PUBLIC_ENV === "development") {
    return {release: false, version: "dev"};
  }
  if (process.env.NEXT_PUBLIC_CI_COMMIT_TAG) {
    return {release: true, version: process.env.NEXT_PUBLIC_CI_COMMIT_TAG};
  }
  if (process.env.NEXT_PUBLIC_CI_COMMIT_SHORT_SHA) {
    const out = {
      branch: null,
      release: false,
      version: process.env.NEXT_PUBLIC_CI_COMMIT_SHORT_SHA,
      timestamp: process.env.NEXT_PUBLIC_CI_COMMIT_TIMESTAMP || "somewhen",
    };
    if (process.env.NEXT_PUBLIC_CI_COMMIT_BRANCH) {
      out.branch = process.env.NEXT_PUBLIC_CI_COMMIT_BRANCH;
    }
    return out;
  }
  return {release: false, version: "???"};
};

export default getAppVersion();
